<template>
  <div id="onboarding-screens">
    <div v-if="!showFinishSetupPage" class="onboarding-get-started">
      <img class="onboarding-image-1" :src="require('../assets/onboarding-1.svg')"/>
      <img class="onboarding-logo" :src="require('../assets/unbabel-logo.svg')"/>
      <h2 class="white-text">Talk to your<br /> customers in their<br /> native language</h2>
      <img class="onboarding-image-2" :src="require('../assets/onboarding-2.svg')"/>
      <div class="onboarding-buttons">
        <a :href="onboardingUrl" target="_blank">
          <Button label="Get started" class="larger-button" button-style="is-primary-inverted"></Button>
        </a>
      <p class="toogleView"  @click="()=>showFinishSetupPage=true">Or click here to finish the setup</p>
      </div>
    </div>

    <!-- 2nd view -->
    <div v-else class="onboarding-finish-setup">
      <div class="shorter-status-content">
        <h2 class="no-box white-text">Paste your Unbabel <br />API key below to <br />get started</h2>
        <a :href="settingsUrl" target="_blank"> What's my Unbabel <br/> API Key?</a>
        <img :src="require('../assets/square.png')"/>
      </div>
      <div v-if="authError" class="wrapper-error-message">
        <p class="error-message">
          {{ authError }}
        </p>
      </div>
      <div class="action-content">
        <InputText
          class="mt-2"
          label="Your Unbabel API Key"
          :data="unbabelApiKey"
          @change="updateAPIKey"
        />
        <Button
          label= "Submit key"
          button-style="is-primary-inverted"
          :disabled= "!unbabelApiKey"
          @click= "submitUnbabelApiKey"
        ></Button>
        <p class="toogleView" @click="()=>showFinishSetupPage=false">Back</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Button, InputText } from '@unbabel/ui'

export default {
  name: 'OnboardingScreen',
  props: ['payload'],
  components: {
    Button,
    InputText
  },
  data: function () {
    return {
      authError: '',
      onboardingUrl: '',
      settingsUrl: '',
      showFinishSetupPage: false,
      unbabelApiKey: ''
    }
  },
  mounted () {
    this.fetchOnboardingPortalParams()
      .then((url) => {
        this.onboardingUrl = url
      })
      .catch(() => this.showError({ message: "Couldn't fetch parameters" }))
    this.fetchPortalSettingsUrl()
      .then((settingsUrl) => {
        this.settingsUrl = settingsUrl
      })
      .catch(() => this.showError({ message: "Couldn't fetch Portal settings url" }))
  },
  methods: {
    ...mapActions([
      'fetchOnboardingPortalParams',
      'signInWithApiKeyAction',
      'globalInitializer',
      'fetchPortalSettingsUrl',
      'fetchPayloadForFirstMessage'
    ]),
    updateAPIKey (val) {
      this.unbabelApiKey = val
    },
    async submitUnbabelApiKey () {
      try {
        await this.signInWithApiKeyAction(this.unbabelApiKey)
        await this.globalInitializer()
        // In case the widget didn't contain the `unbabelToken` up to now, the payload for the 1st translation request would be empty.
        if (Object.keys(this.payload).length === 0) {
          const payload = await this.fetchPayloadForFirstMessage()
          this.$emit('updatePayload', payload.message)
        }
        this.$emit('complete')
      } catch (err) {
        this.authError = err.status === 400 ? 'Your Unbabel API Key is invalid' : `Server error. Please try again.`
      }
    }
  }
}
</script>

<style scoped>

  .white-text {
    color: var(--light-grey);
  }

  .bottom-divider {
    border-bottom: 1px solid #DEE3ED;
  }
  .float-right {
    float: right;
  }
  .m-r-20px {
    margin-right: 20px;
  }
  .m-t-20px {
    margin-top: 20px;
  }
  .m-t-6px {
    margin-top: 6px;
  }

  .m-b-8 {
    margin-bottom: 8px;
  }

  /* Content - general styles */
  .content {
    height: 355px;
  }

  .content h2 {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.15px;
    margin-bottom: 18px;
  }

  .content h3 {
    font-size: 10px;
    line-height: 15px;
    letter-spacing: 1.5px;
    padding-bottom: 8px;
    color: unset; /* override old app css rule */
  }

  /*  */
  /* Onboarding */
  /*  */

  #onboarding-screens{
    height: 100%;
  }

  .onboarding-image-1 {
    margin-top: 8px;
  }

  .onboarding-logo {
    width: 150px;
    margin: 8px 0 16px;
  }

  .onboarding-image-2 {
    margin: 0 32px 4px 0;
  }

  .onboarding-buttons {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }

  .onboarding-buttons a {
    text-decoration: none;
  }

  #demo-button {
    margin-top: 8px;
    border-color: white;
  }

  .blue-background {
    background-color: var(--blue)
  }

  .p-0 {
    padding: 0;
  }

  .onboarding-finish-setup img {
    padding: 0 0 45px 140px;
  }

  .toogleView{
    margin: 1em 0 0 0;
    font-size: 12px;
    width: 70%;
    cursor: pointer;
    color: white;
    text-decoration: underline;
  }

  .wrapper-error-message {
    position: absolute;
    top: 47%;
    display: flex;
    justify-content: center;
    width: 100%;
  }
  .error-message {
    font-size: 10px;
    box-sizing: border-box;
    width: 190px;
    padding: 0.7em 0;
    color: #343941;
    background-color: #FAEBEE;
    border: 2px solid #F8AEBC;
    border-radius: 4px;
  }

  .shorter-status-content {
    height: 65%;
  }

  .shorter-status-content a{
    color: white;
    font-size: 12px;
  }

  .no-box {
    padding: 38px 18px 0;
  }

  .action-content {
    height: 35%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    color: var(--grey)
  }

  .c-Button {
    width: 190px;
    height: 36px;
    justify-content: center;
  }

  .action-content .c-inputText {
    width: 190px;
    height: 48px;
    margin-bottom: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/OnboardingScreen.vue